export var StateItems;

(function (StateItems) {
  StateItems[StateItems["CHECKOUT"] = 0] = "CHECKOUT";
  StateItems[StateItems["SUMMARY_PRICES"] = 1] = "SUMMARY_PRICES";
  StateItems[StateItems["PROMO_CODE"] = 2] = "PROMO_CODE";
  StateItems[StateItems["PAYMENT"] = 3] = "PAYMENT";
  StateItems[StateItems["PAYMENT_GATEWAYS"] = 4] = "PAYMENT_GATEWAYS";
})(StateItems || (StateItems = {}));